var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.setSize(),style:({'background-image': ("url(" + (require('../../assets/archive.png')) + ")")})},[_c('span',{staticClass:"buttonText"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }